import { Vehicle } from './Vehicle';
import { Location } from './Location';
import { Delivery } from './Delivery';

export interface TransportNode {
    id?: number;
    location_id: number | null;
    location_name?: string;
    sequence: number;
}

export interface Transport {
    id?: number;
    vehicle_id?: number;
    vehicle_patent?: string;
    vehicle_type?: string;
    dispatch_date?: string;
    status?: string;
    status_label?: string;
    start_date?: string | null;
    end_date?: string | null;
    is_active?: boolean;
    created_at?: string;
    created_user?: string;
    nodes_count?: number;
    deliveries_count?: number;
    nodes?: TransportNode[];
    deliveries?: Delivery[];
}

export interface TransportDataForm {
    id?: number;
    vehicle_id?: number | null;
    dispatch_date?: string | null;
    status?: string;
    status_label?: string;
    start_date?: string | null;
    end_date?: string | null;
    nodes?: TransportNode[];
    delivery_ids?: number[];
}

export interface TransportFilters {
    id?: number | null;
    vehicle_id?: number | null;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export const defaultTransportDataForm: TransportDataForm = {
    vehicle_id: null,
    dispatch_date: null,
    status: 'CREATED',
    start_date: null,
    end_date: null,
    nodes: [],
    delivery_ids: []
};
